import { ServerTypeOptionsOledb } from '@Types';
import { DbHelpers } from './db-driver-helpers';
import { isNumber } from './stringHelpers';
import { SystemConnectionType } from '@Components';

export class SystemConnectionFormHelpers {
	public static getPort(serverType: string | null) {
		if (serverType === 'ORACLE') return '1521';
		else if (serverType === 'MSSQL') return '1433';
		else if (serverType === ServerTypeOptionsOledb[0]) return '';
		else if (serverType === ServerTypeOptionsOledb[1]) return '';
		else if (serverType === 'MYSQL') return '3306';
		else if (serverType === 'PI') return '5465';
		else if (serverType === 'PIProvider') return '5462';
		else if (serverType === 'ClearSCADA')
			return '5481'; // not sure about this one
		else return '';
	}

	public static getDateOption(serverType: string | null) {
		if (serverType === 'ORACLE') return 'ORACLE';
		else if (serverType === 'MSSQL') return 'ANSI';
		else if (serverType === ServerTypeOptionsOledb[0]) return 'ANSI';
		else if (serverType === ServerTypeOptionsOledb[1]) return 'ANSI';
		else if (serverType === 'MYSQL') return 'ANSI';
		else if (serverType === 'PI') return 'ANSI';
		else if (serverType === 'PIProvider') return 'ANSI';
		else if (serverType === 'ClearSCADA') return 'ANSI';
		else return '';
	}

	public static getQuoteOption(serverType: string | null) {
		if (serverType === 'ORACLE') return 'DOUBLE_QUOTE';
		else if (serverType === 'MSSQL') return 'DOUBLE_QUOTE';
		else if (serverType === ServerTypeOptionsOledb[0])
			return 'DOUBLE_QUOTE';
		else if (serverType === ServerTypeOptionsOledb[1])
			return 'DOUBLE_QUOTE';
		else if (serverType === 'MYSQL') return 'BACK_TICK';
		else if (serverType === 'PI') return 'DOUBLE_QUOTE';
		else if (serverType === 'PIProvider') return 'DOUBLE_QUOTE';
		else if (serverType === 'ClearSCADA') return 'DOUBLE_QUOTE';
		else return '';
	}

	public static getTagFormat(serverType: string | null) {
		if (serverType === 'ORACLE') return 'STRING';
		else if (serverType === 'MSSQL') return 'STRING';
		else if (serverType === ServerTypeOptionsOledb[0]) return 'STRING';
		else if (serverType === ServerTypeOptionsOledb[1]) return 'STRING';
		else if (serverType === 'MYSQL') return 'STRING';
		else if (serverType === 'PI') return 'STRING';
		else if (serverType === 'PIProvider') return 'STRING';
		else if (serverType === 'ClearSCADA') return 'NUMBER';
		else return '';
	}

	public static getTsConversion(serverType: string | null) {
		if (serverType === 'ORACLE') return 'TIMESTAMP_prefix';
		else if (serverType === 'MSSQL') return 'IMPLICIT';
		else if (serverType === ServerTypeOptionsOledb[0]) return 'IMPLICIT';
		else if (serverType === ServerTypeOptionsOledb[1]) return 'IMPLICIT';
		else if (serverType === 'MYSQL') return 'IMPLICIT';
		else if (serverType === 'PI') return 'IMPLICIT';
		else if (serverType === 'PIProvider') return 'IMPLICIT';
		else if (serverType === 'ClearSCADA') return 'TS_function';
		else return '';
	}

	public static getQueryPrefix(serverType: string | null) {
		if (DbHelpers.isOfType('iHistorian', serverType || '')) {
			return 'SET RowCount = 0, IntervalMilliseconds = 60000';
		} else {
			return '';
		}
	}

	public static getQueryGroupSize(serverType: string | null) {
		if (DbHelpers.isOfType('iHistorian', serverType || '')) {
			return '195';
		} else {
			return '1000';
		}
	}

	public static buildSystemConnectionTypes(options: {
		isOpcuaEnabled: boolean | string;
		isOledbEnabled: boolean | string;
		translations: Record<'ODBC' | 'OLEDB' | 'OPC-UA', string>;
	}): SystemConnectionType[] {
		const { isOpcuaEnabled, isOledbEnabled, translations } = options;
		const response: SystemConnectionType[] = [];
		response.push({
			systemConnectionTypeId: 'ODBC',
			systemConnectionTypeName: translations['ODBC'],
		} as SystemConnectionType);
		if (isOledbEnabled) {
			response.push({
				systemConnectionTypeId: 'OLEDB',
				systemConnectionTypeName: translations['OLEDB'],
			});
		}
		if (isOpcuaEnabled) {
			response.push({
				systemConnectionTypeId: 'OPC-UA',
				systemConnectionTypeName: translations['OPC-UA'],
			} as SystemConnectionType);
		}
		return response;
	}

	public static buildOpcuaUrl(
		serverAddress: string,
		port: string,
		resourcePath: string,
	): string {
		let opcuaUrl = 'opc.tcp://';
		if (serverAddress) {
			opcuaUrl += serverAddress;
		}
		if (isNumber(port)) {
			opcuaUrl += ':' + port;
		}
		if (resourcePath) {
			opcuaUrl += '/' + resourcePath;
		}
		return opcuaUrl;
	}
}
